import React from 'react';
class Platform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      limit: props.h && props.width < 768 ? props.h + 'px' : '600px',
      height: 'auto',
      width: props.w,
    };
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }
  toggleVisibility() {
    this.setState({ show: !this.state.show, height: this.state.height == 'auto' ? this.state.limit : 'auto' });

    if (this.state.show) {
      this.props.scrollToPlatform(this.props.id, 40, true);
    }
  }
  show() {
    this.setState({ show: true, height: 'auto' });
  }
  componentDidMount() {
    if (!this.props.show) {
      this.setState({ show: false, height: this.state.limit });
    } else {
      this.setState({ show: true, height: 'auto' });
    }
  }
  componentWillReceiveProps(nextProps, nextContext) {
    if (!nextProps.show) {
      if (nextProps.width != 0) {
        if (nextProps.width < 768) {
          this.setState({ height: nextProps.h, limit: nextProps.h });
        } else {
          this.setState({ limit: '600px' });
        }
      } else {
        this.setState({ limit: '600px', height: '600px' });
      }
      this.setState({ show: false });
    } else {
      this.setState({ show: true, height: 'auto' });
    }
  }
  render() {
    return (
      <div
        ref={divElement => {
          this.divElement = divElement;
        }}
        className="relative"
        id={this.props.id}
      >
        <div style={{ height: this.state.height }} className="hidden overflow-hidden md:block">
          {this.props.children}
        </div>
        <div className="block overflow-hidden md:hidden">{this.props.children}</div>
        <div className="absolute bottom-0 left-0 right-0 z-10 justify-center hidden w-full md:flex">
          <div
            onClick={this.toggleVisibility}
            className={
              'flex justify-center items-center bg-green -mb-15 rounded-5 mx-auto text-center cursor-pointer ' +
              (this.state.show ? 'transform rotate-180' : '')
            }
          >
            <div className="scroll-down-animation" />
          </div>
        </div>
        <div className={'hidden md:blcok w-full'}>
          <div
            className="absolute bottom-0 w-full h-15 -mb-15"
            style={{
              boxShadow: '0px -3px 4px rgba(0, 0, 0, 0.1)',
              display: !this.state.show ? 'flex' : 'none',
            }}
          />
        </div>
        <style jsx global>
          {`
            .scroll-down-animation {
              position: relative;
              display: block;
              opacity: 0;
              transition: all 0.4s ease;
              line-height: 0;
              font-size: 0;
              color: transparent;
              margin-left: auto;
              margin-right: auto;
              width: 50px;
              height: 48px;
              background-size: 0 auto;
              animation: pulse 1.5s 0s infinite normal ease forwards;
              background-image: url('/images/icons/arrow-bottom-white-animation.svg');
              background-repeat: no-repeat;
              margin-top: -10px;
              margin-bottom: -10px;
            }
            .scroll-down-animation:before,
            .scroll-down-animation:after {
              content: ' ';
              position: absolute;
              top: 0;
              left: 0;
              display: block;
              width: 100%;
              height: 100%;
              background: url('/images/icons/arrow-bottom-white-animation.svg') no-repeat center top;
              background-size: 100% auto;
            }
            .scroll-down-animation:before {
              animation: pulse 1.5s 0.25s infinite normal ease forwards;
            }
            .scroll-down-animation:after {
              animation: pulse 1.5s 0.5s infinite normal ease forwards;
            }

            @keyframes pulse {
              0% {
                opacity: 0;
                background-position: center top;
                background-size: 0 auto;
              }
              10% {
                opacity: 0;
              }
              50% {
                opacity: 1;
                background-size: 75% auto;
              }
              90% {
                opacity: 0;
              }
              100% {
                opacity: 0;
                background-position: center bottom;
                background-size: 0 auto;
              }
            }
          `}
        </style>
      </div>
    );
  }
}
export default Platform;
